/* ============================================
   TC CART JS - Quick Add & Wishlist
   triathlon.tc / Glozin tema entegrasyonu
   ============================================ */

var TCCart = (function () {
  'use strict';

  var _currentProduct = null;
  var _selectedVariantId = null;
  var _addedVariantId = null;   // "Sepete Ekle" ile az önce eklenen varyant
  var WISHLIST_KEY = 'glozin__wishlist-items';

  // ===== QUICK ADD =====
  function openQuickAdd(handle) {
    var modal = document.getElementById('tc-quick-add-modal');
    var overlay = document.getElementById('tc-quick-add-overlay');
    var body = document.getElementById('tc-qam-body');

    if (!modal) { console.error('TC: quick-add modal bulunamadı'); return; }

    body.innerHTML = '<div class="tc-qam-loading"><div class="tc-qam-spinner"></div><span>Yükleniyor...</span></div>';
    modal.classList.add('open');
    modal.style.pointerEvents = 'auto';
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    _selectedVariantId = null;
    _addedVariantId = null;

    fetch('/products/' + handle + '.js')
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(product) {
        _currentProduct = product;
        _renderQuickAdd(product);
      })
      .catch(function(err) {
        console.error('TC QuickAdd error:', err);
        body.innerHTML = '<div class="tc-qam-error"><p>Ürün yüklenemedi.</p><a href="/products/' + handle + '" style="color:#000;font-size:13px;">Ürün sayfasına git →</a></div>';
      });
  }

  function closeQuickAdd() {
    var modal = document.getElementById('tc-quick-add-modal');
    var overlay = document.getElementById('tc-quick-add-overlay');
    modal.style.pointerEvents = '';
    if (modal) modal.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
    _currentProduct = null;
    _selectedVariantId = null;
  }

  function _renderQuickAdd(product) {
    var body = document.getElementById('tc-qam-body');
    if (!body) return;

    // Resim - protocol-relative URL düzelt
    var image = product.featured_image || (product.images && product.images[0]) || null;
    if (image && typeof image === 'string' && image.indexOf('//') === 0) {
      image = 'https:' + image;
    }

    // Fiyat hesapla
    var priceHTML = '';
    if (product.compare_at_price_max && product.compare_at_price_max > product.price_min) {
      var pct = Math.round((product.compare_at_price_max - product.price_min) * 100 / product.compare_at_price_max);
      priceHTML = '<span class="tc-qam-price-sale">' + _formatMoney(product.price_min) + '</span>' +
                  '<span class="tc-qam-price-compare">' + _formatMoney(product.compare_at_price_max) + '</span>' +
                  '<span class="tc-qam-badge-sale">-%' + pct + '</span>';
    } else {
      priceHTML = '<span class="tc-qam-price-regular">' + _formatMoney(product.price_min) + '</span>';
    }

    // Option analizi - Beden/Size hangisi
    var sizeOptionIndex = -1;
    var sizeLabel = 'Seçenek';
    if (product.options && product.options.length > 0) {
      for (var i = 0; i < product.options.length; i++) {
        var optName = typeof product.options[i] === 'object' ? product.options[i].name : String(product.options[i]);
        var optLower = optName.toLowerCase();
        if (optLower === 'beden' || optLower === 'size' || optLower === 'numara' || optLower === 'boy') {
          sizeOptionIndex = i;
          sizeLabel = optName;
          break;
        }
      }
      // Bulunamazsa ilk option'ı kullan (örn. renk veya tek option)
      if (sizeOptionIndex === -1) {
        sizeOptionIndex = 0;
        sizeLabel = typeof product.options[0] === 'object' ? product.options[0].name : String(product.options[0]);
      }
    }

    // Tek variant ve single option mi?
    var hasSingleVariant = product.variants && product.variants.length === 1 && product.variants[0].title === 'Default Title';

    // Beden grid HTML
    var sizesHTML = '';
    if (!hasSingleVariant && product.variants && product.variants.length > 0) {
      sizesHTML = '<div class="tc-qam-sizes">' +
        '<div class="tc-qam-section-label">' + sizeLabel + ' Seç <span id="tc-qam-selected-size"></span></div>' +
        '<div class="tc-qam-size-grid" id="tc-qam-size-grid">';

      var seen = {};
      product.variants.forEach(function(v) {
        var optKey = 'option' + (sizeOptionIndex + 1);
        var sizeVal = v[optKey] || v.title;
        if (seen[sizeVal]) return;
        seen[sizeVal] = true;
        var avail = v.available;
        sizesHTML += '<button type="button" ' +
          'class="tc-qam-size-btn' + (avail ? '' : ' unavailable') + '" ' +
          'data-variant-id="' + v.id + '" ' +
          'data-size="' + sizeVal + '" ' +
          (avail ? '' : 'disabled ') +
          'onclick="TCCart.selectSize(this)">' +
          sizeVal + '</button>';
      });

      sizesHTML += '</div></div>';
    } else if (hasSingleVariant) {
      _selectedVariantId = product.variants[0].id;
    }

    var submitDisabled = (!hasSingleVariant && product.variants && product.variants.length > 1) ? 'disabled' : '';
    var submitText = submitDisabled ? sizeLabel + ' Seçin' : 'Sepete Ekle';

    var html = '<div class="tc-qam-product">' +
      '<div class="tc-qam-image-wrap">' +
        (image ? '<img src="' + image + '" alt="' + _escapeHtml(product.title) + '" class="tc-qam-image">' : '') +
      '</div>' +
      '<div class="tc-qam-details">' +
        '<div class="tc-qam-vendor">' + _escapeHtml(product.vendor || '') + '</div>' +
        '<h2 class="tc-qam-title">' + _escapeHtml(product.title) + '</h2>' +
        '<div class="tc-qam-price-row">' + priceHTML + '</div>' +
        sizesHTML +
        '<button type="button" id="tc-qam-submit" class="tc-qam-submit" onclick="TCCart.addToCart()" ' + submitDisabled + '>' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
          submitText +
        '</button>' +
        /* Hemen Satın Al: sepete ekleyip doğrudan ödemeye gider.
           Yalnız mobilde görünür (tc-filters.css .tc-qam-buynow). */
        '<button type="button" id="tc-qam-buynow" class="tc-qam-buynow" onclick="TCCart.buyNow()" ' + submitDisabled + '>Hemen Satın Al</button>' +
        '<a href="/products/' + product.handle + '" class="tc-qam-detail-link">Ürün Detayına Git →</a>' +
      '</div>' +
    '</div>';

    body.innerHTML = html;
  }

  function selectSize(btn) {
    var grid = document.getElementById('tc-qam-size-grid');
    if (grid) {
      grid.querySelectorAll('.tc-qam-size-btn').forEach(function(b) { b.classList.remove('selected'); });
    }
    btn.classList.add('selected');
    _selectedVariantId = btn.getAttribute('data-variant-id');

    var sizeLabel = document.getElementById('tc-qam-selected-size');
    if (sizeLabel) sizeLabel.textContent = '— ' + btn.getAttribute('data-size');

    var submit = document.getElementById('tc-qam-submit');
    if (submit) {
      submit.disabled = false;
      submit.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>Sepete Ekle';
    }
    var buyNowBtn = document.getElementById('tc-qam-buynow');
    if (buyNowBtn) buyNowBtn.disabled = false;
  }

  /* Hemen Satın Al: seçili varyantı sepete ekleyip /checkout'a gider.
     Aynı varyant az önce "Sepete Ekle" ile eklendiyse ikinci kez eklemez. */
  function buyNow() {
    if (!_selectedVariantId) return;
    var btn = document.getElementById('tc-qam-buynow');

    if (_addedVariantId === _selectedVariantId) {
      window.location.href = '/checkout';
      return;
    }
    if (btn) { btn.disabled = true; btn.textContent = 'Yönlendiriliyor...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(_selectedVariantId), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status && data.status >= 400) {
        if (btn) { btn.disabled = false; btn.textContent = data.description || 'Hata, tekrar dene'; }
        return;
      }
      window.location.href = '/checkout';
    })
    .catch(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Hata, tekrar dene'; }
    });
  }

  function addToCart() {
    if (!_selectedVariantId) return;

    var submit = document.getElementById('tc-qam-submit');
    if (submit) { submit.disabled = true; submit.textContent = 'Ekleniyor...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(_selectedVariantId), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status && data.status >= 400) {
        if (submit) { submit.disabled = false; submit.textContent = data.description || 'Hata, tekrar dene'; }
        return;
      }
      _addedVariantId = _selectedVariantId;
      _showCartSuccess(submit);
      _updateCartCount();
      /* Otomatik kapatma KALDIRILDI: buton artık "Sepete Git"e dönüşüyor,
         modal kapanırsa kullanıcı o butona ulaşamıyordu. */
    })
    .catch(function() {
      if (submit) { submit.disabled = false; submit.textContent = 'Hata, tekrar dene'; }
    });
  }

  /* Ekleme başarılı: buton "Sepete Git"e dönüşür.
     ÖNEMLİ: inline onclick="TCCart.addToCart()" MUTLAKA temizlenmeli — eskiden
     buton success durumunda tekrar enable ediliyor ama handler'ı değişmediği
     için ikinci tık ürünü İKİNCİ KEZ sepete ekliyordu. */
  function _showCartSuccess(btn) {
    if (!btn) return;

    btn.disabled = false;
    btn.classList.add('tc-qam-submit-success');
    btn.removeAttribute('onclick');
    btn.onclick = function (e) {
      if (e) e.preventDefault();
      window.location.href = '/cart';
    };
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">'
      + '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>'
      + '<path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>Sepete Git →';

    /* Bilgi satırı + "alışverişe devam et" — yalnız bir kez eklenir */
    var details = btn.parentNode;
    if (details && !details.querySelector('.tc-qam-added-note')) {
      var note = document.createElement('div');
      note.className = 'tc-qam-added-note';
      note.textContent = 'Ürün sepete eklendi.';
      details.insertBefore(note, btn);

      var cont = document.createElement('button');
      cont.type = 'button';
      cont.className = 'tc-qam-continue';
      cont.textContent = 'Alışverişe Devam Et';
      cont.addEventListener('click', function () { closeQuickAdd(); });
      if (btn.nextSibling) {
        details.insertBefore(cont, btn.nextSibling);
      } else {
        details.appendChild(cont);
      }
    }
  }

  function _updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .site-header__cart-count, .h-count').forEach(function(el) {
          if (!el.closest('.wishlist-count') && !el.classList.contains('wishlist-count')) {
            el.textContent = cart.item_count;
          }
        });
      });
  }

  // ===== WİSHLİST - Glozin tema entegrasyonu =====
  function toggleWishlist(btn, productId) {
    productId = String(productId);
    var items = _getWishlistItems();
    var idx = items.indexOf(productId);

    if (idx === -1) {
      items.push(productId);
      btn.classList.add('tc-btn-wishlist-active');
    } else {
      items.splice(idx, 1);
      btn.classList.remove('tc-btn-wishlist-active');
    }

    // Glozin localStorage'a kaydet
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));

    // Header sayacını güncelle
    document.querySelectorAll('.wishlist-count').forEach(function(el) {
      el.innerText = items.length > 0 ? items.length : 0;
    });

    // Temadaki diğer wishlist butonlarını da senkronize et
    var themeButtons = document.querySelectorAll('button-wishlist[data-product-id="' + productId + '"]');
    themeButtons.forEach(function(tbtn) {
      if (idx === -1) {
        tbtn.classList.add('active');
      } else {
        tbtn.classList.remove('active');
      }
    });
  }

  function _getWishlistItems() {
    try {
      var stored = localStorage.getItem(WISHLIST_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch(e) {
      return [];
    }
  }

  // Sayfa yüklendiğinde favori butonların durumunu senkronize et
  function _syncWishlistButtons() {
    var items = _getWishlistItems();
    document.querySelectorAll('.tc-btn-wishlist[data-product-id]').forEach(function(btn) {
      var id = String(btn.getAttribute('data-product-id'));
      if (items.indexOf(id) !== -1) {
        btn.classList.add('tc-btn-wishlist-active');
      }
    });
  }

  function _escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function _formatMoney(cents) {
    /* Sitenin geri kalanı "1.234,56 TL" biçiminde yazıyor; buradaki eksik
       boşluk quick-add modalında "1.234,56TL" görünmesine yol açıyordu. */
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  // Escape ile kapat
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeQuickAdd();
  });

  // DOM hazır olunca wishlist butonlarını senkronize et
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _syncWishlistButtons);
  } else {
    _syncWishlistButtons();
  }

  return {
    openQuickAdd: openQuickAdd,
    closeQuickAdd: closeQuickAdd,
    selectSize: selectSize,
    addToCart: addToCart,
    buyNow: buyNow,
    toggleWishlist: toggleWishlist
  };

})();
